<template>
  <navbar :show-navbar="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar"></navbar-toggle-button>
      </div>
      <a class="navbar-brand"><strong>{{this.$route.name}}</strong></a>
    </div>

    <template slot="navbar-menu">
      <ul class="navbar-nav">
        <drop-down icon="nc-icon nc-bell-55" tag="li"
                   position="right"
                   direction="none"
                   class="nav-item dropdown">
          <a title="Notifications" slot="title"
             slot-scope="{isOpen}"
             class="nav-link"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="nc-icon nc-bell-55"></i>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <a class="dropdown-item"
            v-for="notification in recentNotifications"
            :class="notification.seenAt ? 'bg-notication-seen' : 'bg-notification-unseen'"
            @click.prevent="updateSeenAtAndOpen(notification)"
            href="#">{{ maybeTruncateMessage(notification.message) }}
          </a>
          <a class="dropdown-item" @click.prevent="openNotifications" href="#">All Notifications</a>
        </drop-down>
        <div class="button-count" v-if="notSeenCount > 0">{{ notSeenCount }}</div>
        <li class="nav-item">
          <a class="nav-link"
             aria-haspopup="true"
             title="Logs"
             @click.prevent="$router.push('/logs/search')"
             href="#">
            <i class="nc-icon nc-single-copy-04"></i>
            <p></p>
          </a>
        </li>
        <li class="nav-item" v-if="canReadHistory()">
          <a class="nav-link"
             aria-haspopup="true"
             title="History"
             @click.prevent="$router.push('/history/search')"
             href="#">
            <i class="nc-icon nc-watch-time"></i>
            <p></p>
          </a>
        </li>
        <drop-down icon="nc-icon nc-single-02" tag="li"
                   position="right"
                   direction="none"
                   class="nav-item dropdown">
          <a title="Profile" slot="title"
             slot-scope="{isOpen}"
             class="nav-link"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="nc-icon nc-single-02"></i>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <a class="dropdown-item" v-if="isAuthenticated" href="#" @click.prevent="editProfile">Profile</a>
          <a class="dropdown-item" v-if="isAuthenticated" href="#" @click.prevent="logout">Logout</a>
        </drop-down>
      </ul>
    </template>
  </navbar>
</template>
<script>
  import {Navbar, NavbarToggleButton} from 'src/components/UIComponents'
  import {mapGetters} from 'vuex'
  import {weeksAgo, objectById} from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'
  import Permissions from 'src/utilities/permissions'

  export default {
    components: {
      Navbar,
      NavbarToggleButton
    },
    data() {
      return {
        activeNotifications: false,
        showNavbar: false
      }
    },
    computed: {
      ...mapGetters({
        userId: 'security/userId',
        sortedDepartments: 'departments/kvpsForSelect',
        users: 'users/results',
        notifications: 'users/notifications/results',
        notSeenCount: 'users/notifications/notSeenCount'
      }),
      recentNotifications() {
        return this.notifications.slice(0, 15)
      },
      isAuthenticated() {
        return this.$auth && this.$auth.isAuthenticated
      }
    },
    methods: {
      editProfile() {
        if (this.userId) {
          const user = objectById(this.users, this.userId)
          this.$eventHub.$emit('show-modal-1', 'Edit User', user, '1000px')
        }
      },
      openNotifications() {
        if (!this.$route.path.includes('/users/notifications')) {
          this.$router.push({path: '/users/notifications'})
        }
      },
      canReadHistory() {
        return this.$can('read', Permissions.HISTORY)
      },
      logout() {
        this.$eventHub.$emit('logout')
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      fetchNotifications() {
        if (!this.userId) {
          return
        }

        const numWeeks = 1
        const payload = {
          userId: this.userId,
          createdAt: weeksAgo(numWeeks)
        }
        this.$store.dispatch('users/notifications/fetchNWeeksNotifications', payload)
      },
      pollNotifications() {
        this.fetchNotifications() // on page load
        // refresh notifications every 1 minute - this might need tuning
        setInterval(() => {
          this.fetchNotifications()
        }, Constants.TIME.MILLIS.ONE_MINUTE)
      },
      updateSeenAtAndOpen(notification) {
        const putPayload = this.$store.getters['users/notifications/putPayload'](notification)
        this.$store.dispatch('put', putPayload)

        switch(notification.entityType) {
          case Constants.ENTITIES.PROJECT:
            this.$router.push({path: `/projects/${notification.route}`})
            break
          case Constants.ENTITIES.JOB:
            this.$eventHub.$emit('show-modal-1', 'Edit Job', {id: notification.route})
            break
          case Constants.ENTITIES.COMPANY:
            this.$eventHub.$emit('show-modal-2', 'Company', {id: notification.route}, '1000px')
            break
          case Constants.ENTITIES.TASK:
            this.$eventHub.$emit('show-modal-2', 'Edit Task', {id: notification.route})
            break
          case Constants.ENTITIES.COMMENT:
            this.$router.push({path: notification.route})
        }
      },
      maybeTruncateMessage(message) {
        if (message && message.length > 25) {
          message = message.substring(0, 25) + '...'
        }
        return message
      }
    },
    mounted() {
      this.$eventHub.$once('userAuthenticated', this.pollNotifications)
    },
    destroyed() {
      this.$eventHub.$off('userAuthenticated')
    }
  }
</script>
<style scoped>
  .dropdown-item, .nav-link {
    cursor: pointer;
  }
</style>
